const resources = {
  "en": {
    "subscription": {
      "title": "Subscription",
      "currentPlan": "Current plan",
      "currentStatus": "Current status",
      "period": "Period: {{start}} – {{end}}",
      "friendsEnds": "Friends access ends on {{date}}",
      "friendsUpgradeNotice": "If you switch plans now, Friends access will end immediately and your new paid plan will start right away.",
      "basic": "Essential Plan",
      "full": "Growth Plan",
      "friends": "Friends Plan",
      "subscriptionActive": "Subscription Active",
      "proceedToCheckout": "Proceed to Checkout",
      "proceedToCheckoutWithPrice": "Proceed to checkout – {{price}}",
      "proceedToCheckoutWithDiscount": "Proceed to checkout – {{price}} (save {{discount}})",
      "checkoutSummary": "{{price}}/month • Auto-renew • Cancel anytime",
      "checkoutSummaryFriends_one": "{{price}} one-time • No auto-renew • Ends in {{count}} day",
      "checkoutSummaryFriends_other": "{{price}} one-time • No auto-renew • Ends in {{count}} days",
      "checkoutSummaryFriendsFallback": "{{price}} one-time • No auto-renew • Ends after 4 months",
      "planSelectionTitle": "Choose your plan",
      "planSelectionDescription": "Compare features and pick the level that fits your workflow.",
      "planSelectionShow": "Choose a new plan",
      "planSelectionHide": "Hide plans",
      "manageTitle": "Manage subscription",
      "manageDescription": "Review your current plan, cancel auto-renewal, or switch to another plan.",
      "plans": {
        "basic": {
          "title": "Essential Plan",
          "headline": "Start building reliable money habits",
          "description": "Stay organized with accounts, budgets, and deadlines.",
          "features": [
            "Track accounts and transactions in one place",
            "Plan budgets with unlimited categories",
            "Manage deadlines without automatic reminders"
          ]
        },
        "full": {
          "title": "Growth Plan",
          "headline": "Unlock automations and shared insights",
          "description": "Advanced planning with structured AI reports.",
          "features": [
            "Cash flow forecast with a single scenario",
            "39 AI credits each month",
            "Accounts, budgets, categories, and deadlines"
          ]
        },
        "ai": {
          "title": "AI Insights Plan",
          "headline": "Tap into AI copilots for proactive insights",
          "description": "Higher AI credit limit for structured AI reports.",
          "features": [
            "99 AI credits every month",
            "Cash flow forecast with a single scenario",
            "Accounts, budgets, categories, and deadlines"
          ]
        },
        "friends": {
          "title": "Friends Plan",
          "headline": "Invite-only access for friends of the project",
          "description": "Special invite-only plan for friends of the project.",
          "features": [
            "Core budgeting, accounts, and task tracking",
            "5 AI credits each month",
            "Access lasts 4 months and ends automatically"
          ]
        }
      },
      "planSelectionRequired": "Select a subscription plan before continuing.",
      "changePlan": "Change Plan",
      "manageSubscription": "Manage Subscription",
      "paymentSuccess": "Payment successful",
      "paymentCanceled": "Payment canceled",
      "confirmingPayment": "Verifying payment...",
      "paymentPending": "Payment not completed yet",
      "paymentCheckFailed": "Payment verification failed",
      "planUpdated": "Plan updated",
      "billingIssue": {
        "title": "Payment issue detected",
        "description": "Your previous subscription is still awaiting payment. Please settle it or cancel the subscription before starting a new plan.",
        "portalAction": "Pay current subscription",
        "reconcileAction": "Refresh billing status",
        "reconcileSuccess": "Billing status refreshed",
        "reconcileError": "Failed to refresh billing status",
        "cancelAction": "Cancel subscription now",
        "cancelSuccess": "Subscription cancelled",
        "cancelError": "Failed to cancel subscription",
        "portalError": "Unable to open the billing portal. Please try again.",
        "blocked": "Resolve the outstanding payment before starting a new subscription.",
        "latestFailureAt": "Latest failed attempt: {{value}}"
      },
      "friendsEnded": {
        "title": "Friends subscription ended",
        "description": "Your Friends plan has finished. You can pick any new plan below or start account deletion.",
        "deleteAccountAction": "Start account deletion"
      },
      "errors": {
        "generic": "Something went wrong while updating your subscription. Please try again.",
        "checkoutFailed": "Could not start checkout. Please try again.",
        "changePlanFailed": "Could not update your plan. Please try again.",
        "autoRenewUpdateFailed": "Could not update auto-renewal. Please try again.",
        "stripeNotConfigured": "Payments are temporarily unavailable.",
        "invalidPlan": "Selected plan is not available.",
        "unauthorized": "Please sign in to manage your subscription.",
        "subscriptionAlreadyActive": "Your subscription is already active.",
        "promoReservationFailed": "Unable to reserve the promo code for checkout.",
        "promoInvalid": "Promo code cannot be applied to this checkout.",
        "promoStripeError": "Payment provider rejected the promo code. Try again or contact support.",
        "noActiveSubscription": "Active subscription not found.",
        "subscriptionItemsMissing": "We could not locate subscription items to update.",
        "changeLocked": "Subscription changes are temporarily locked. Please try again later.",
        "paymentRequired": "Please settle the existing subscription payment before starting a new plan."
      },
      "aiCreditsBalance": "AI credits balance: {{balance}}",
      "activePromotionsTitle": "Active promotions",
      "autoRenew": {
        "title": "Auto-renewal",
        "active": "Auto-renewal is active.",
        "cancelled": "Auto-renewal will stop on {{date}}.",
        "cancelledNoDate": "Auto-renewal is disabled.",
        "cancelAction": "Cancel auto-renewal",
        "resumeAction": "Resume auto-renewal",
        "modalCancelTitle": "Cancel auto-renewal?",
        "modalResumeTitle": "Resume auto-renewal?",
        "modalCancelDescription": "You will keep access until {{date}}. After that your plan will switch to Free.",
        "modalResumeDescription": "Your subscription will continue renewing every period.",
        "modalConfirmCancel": "Cancel auto-renewal",
        "modalConfirmResume": "Resume auto-renewal",
        "modalDismiss": "Go back",
        "toastDisabled": "Auto-renewal disabled",
        "toastDisabledWithDate": "Auto-renewal will stop on {{date}}",
        "toastEnabled": "Auto-renewal enabled",
        "cancelSuccess": "Auto-renewal disabled",
        "cancelError": "Failed to disable auto-renewal",
        "resumeSuccess": "Auto-renewal enabled",
        "resumeError": "Failed to enable auto-renewal",
        "unknownDate": "an unknown date"
      },
      "promo": {
        "title": "Promo codes",
        "placeholder": "Enter promo code",
        "applyCta": "Apply",
        "clearCta": "Remove",
        "successTitle": "Promo code applied",
        "errorTitle": "Unable to apply promo code",
        "modalOk": "Got it",
        "successFallback": "Promo code accepted.",
        "infoAppliedToPlan": "Promo will be applied at checkout for the {{plan}} plan.",
        "planNotEligible": "Promo code does not apply to the {{plan}} plan.",
        "appliedTag": "Promo applied: {{code}}",
        "discount": {
          "percent": "{{value}}% off",
          "amount": "{{value}} off"
        },
        "success": "Promo code applied successfully.",
        "validating": "Validating promo code…",
        "applying": "Applying promo code…",
        "statuses": {
          "valid": "Promo code is valid.",
          "reserved": "Promo code reserved for checkout."
        },
        "errors": {
          "promo_missing_code": "Enter a promo code to continue.",
          "not_found": "Promo code not found.",
          "expired": "This promo code has expired.",
          "assigned_to_other": "This promo code is assigned to a different user.",
          "plan_not_allowed": "Promo code cannot be applied to the selected plan.",
          "maxed_out": "Promo code has reached the maximum number of redemptions.",
          "already_used": "You have already used this promo code.",
          "reservation_failed": "Promo code is no longer available.",
          "promo_invalid": "Promo code cannot be applied.",
          "promo_reservation_failed": "Unable to reserve promo code. Try again later.",
          "promo_stripe_error": "Stripe rejected the promo code. Try again or contact support.",
          "subscription_not_found": "Active subscription not found.",
          "stripe_not_configured": "Payments are temporarily unavailable.",
          "unauthorized": "You must sign in to apply a promo code."
        }
      },
      "planCard": {
        "selectCta": "Choose plan",
        "upgradeCta": "Upgrade",
        "selectedCta": "Selected",
        "currentTag": "Current",
        "selectedTag": "Selected",
        "promoEligible": "Promo eligible",
        "promoNotEligible": "Promo locked",
        "perMonth": "per month",
        "discountedPrice": "After promo: {{price}}",
        "aiCreditsPerPeriod": "{{count}} AI credits / month"
      },
      "friends": {
        "title": "Friends Plan",
        "subtitle": "Invite-only access for friends of the project.",
        "details": "One-time access for 4 months with 5 AI credits each month. It ends automatically.",
        "price": "Price: {{price}}",
        "cta": "Activate Friends Plan"
      },
      "statuses": {
        "inactive": "Inactive",
        "trialing": "Trialing",
        "active": "Active",
        "past_due": "Past due",
        "unpaid": "Unpaid",
        "incomplete": "Incomplete",
        "incomplete_expired": "Incomplete (expired)",
        "paused": "Paused",
        "canceled": "Canceled",
        "grace": "Grace period",
        "expired": "Expired"
      }
    }
  },
  "uk": {
    "subscription": {
      "title": "Підписка",
      "currentPlan": "Поточний план",
      "currentStatus": "Поточний статус",
      "period": "Період: {{start}} – {{end}}",
      "friendsEnds": "Доступ Friends завершується {{date}}",
      "friendsUpgradeNotice": "Якщо перейти на новий план зараз, доступ Friends завершиться одразу, а новий платний план почне діяти відразу.",
      "basic": "План Essential",
      "full": "План Growth",
      "friends": "Friends Plan",
      "subscriptionActive": "Підписка активна",
      "proceedToCheckout": "Перейти до оплати",
      "proceedToCheckoutWithPrice": "Перейти до оплати – {{price}}",
      "proceedToCheckoutWithDiscount": "Перейти до оплати – {{price}} (економія {{discount}})",
      "checkoutSummary": "{{price}}/місяць • Автопоновлення • Можна скасувати будь-коли",
      "checkoutSummaryFriends_one": "{{price}} одноразово • Без автопоновлення • Завершиться через {{count}} день",
      "checkoutSummaryFriends_few": "{{price}} одноразово • Без автопоновлення • Завершиться через {{count}} дні",
      "checkoutSummaryFriends_many": "{{price}} одноразово • Без автопоновлення • Завершиться через {{count}} днів",
      "checkoutSummaryFriendsFallback": "{{price}} одноразово • Без автопоновлення • Завершиться через 4 місяці",
      "planSelectionTitle": "Оберіть свій план",
      "planSelectionDescription": "Порівняйте можливості та оберіть рівень, що підходить вашому робочому процесу.",
      "planSelectionShow": "Обрати новий план",
      "planSelectionHide": "Сховати плани",
      "manageTitle": "Керування підпискою",
      "manageDescription": "Перегляньте поточний план, скасуйте автопродовження або змініть тариф.",
      "plans": {
        "basic": {
          "title": "План Essential",
          "headline": "Почніть формувати надійні фінансові звички",
          "description": "Залишайтеся організованими зі рахунками, бюджетами та дедлайнами.",
          "features": [
            "Відстежуйте рахунки та транзакції в одному місці",
            "Плануйте бюджети з необмеженими категоріями",
            "Керуйте дедлайнами без автоматичних нагадувань"
          ]
        },
        "full": {
          "title": "План Growth",
          "headline": "Відкрийте автоматизації та спільні інсайти",
          "description": "Розширене планування зі структурованими AI‑звітами.",
          "features": [
            "Прогноз грошового потоку в одному сценарії",
            "39 AI‑кредитів щомісяця",
            "Рахунки, бюджети, категорії та дедлайни"
          ]
        },
        "ai": {
          "title": "План AI Insights",
          "headline": "Скористайтеся AI‑копілотами для проактивних інсайтів",
          "description": "Більший ліміт AI‑кредитів для структурованих AI‑звітів.",
          "features": [
            "99 AI‑кредитів щомісяця",
            "Прогноз грошового потоку в одному сценарії",
            "Рахунки, бюджети, категорії та дедлайни"
          ]
        },
        "friends": {
          "title": "Friends Plan",
          "headline": "Доступ лише за запрошенням",
          "description": "Спеціальний план, що відкриває основні можливості Finance.",
          "features": [
            "Базові бюджети, рахунки та завдання",
            "5 AI‑кредитів щомісяця",
            "Доступ на 4 місяці з автоматичним завершенням"
          ]
        }
      },
      "planSelectionRequired": "Оберіть план підписки перед продовженням.",
      "changePlan": "Змінити план",
      "manageSubscription": "Керувати підпискою",
      "paymentSuccess": "Оплату успішно завершено",
      "paymentCanceled": "Оплату скасовано",
      "confirmingPayment": "Перевіряємо оплату...",
      "paymentPending": "Оплату ще не завершено",
      "paymentCheckFailed": "Не вдалося перевірити оплату",
      "planUpdated": "План оновлено",
      "billingIssue": {
        "title": "Проблема з оплатою",
        "description": "Попередня підписка все ще очікує на оплату. Погасіть її або скасуйте підписку перед оформленням нового плану.",
        "portalAction": "Оплатити поточну підписку",
        "reconcileAction": "Оновити білінговий статус",
        "reconcileSuccess": "Білінговий статус оновлено",
        "reconcileError": "Не вдалося оновити білінговий статус",
        "cancelAction": "Скасувати підписку зараз",
        "cancelSuccess": "Підписку скасовано",
        "cancelError": "Не вдалося скасувати підписку",
        "portalError": "Не вдалося відкрити білінг-портал. Спробуйте ще раз.",
        "blocked": "Спочатку врегулюйте заборгованість за підпискою.",
        "latestFailureAt": "Остання невдала спроба: {{value}}"
      },
      "friendsEnded": {
        "title": "Friends-підписка завершена",
        "description": "Ваш план Friends завершився. Нижче можна обрати новий план або розпочати видалення акаунта.",
        "deleteAccountAction": "Розпочати видалення акаунта"
      },
      "errors": {
        "generic": "Під час оновлення підписки сталася помилка. Спробуйте ще раз.",
        "checkoutFailed": "Не вдалося розпочати оплату. Спробуйте ще раз.",
        "changePlanFailed": "Не вдалося оновити ваш план. Спробуйте ще раз.",
        "autoRenewUpdateFailed": "Не вдалося оновити автопродовження. Спробуйте ще раз.",
        "stripeNotConfigured": "Платежі тимчасово недоступні.",
        "invalidPlan": "Обраний план недоступний.",
        "unauthorized": "Увійдіть, щоб керувати підпискою.",
        "subscriptionAlreadyActive": "Ваша підписка вже активна.",
        "promoReservationFailed": "Не вдалося зарезервувати промокод для оплати.",
        "promoInvalid": "Промокод не можна застосувати до цієї оплати.",
        "promoStripeError": "Платіжний провайдер відхилив промокод. Спробуйте ще раз або зверніться до підтримки.",
        "noActiveSubscription": "Активну підписку не знайдено.",
        "subscriptionItemsMissing": "Не вдалося знайти елементи підписки для оновлення.",
        "changeLocked": "Зміни підписки тимчасово заблоковані. Спробуйте пізніше.",
        "paymentRequired": "Перш ніж оформити новий план, потрібно закрити оплату поточної підписки."
      },
      "aiCreditsBalance": "Баланс AI‑кредитів: {{balance}}",
      "activePromotionsTitle": "Активні промоакції",
      "autoRenew": {
        "title": "Автопродовження",
        "active": "Автопродовження активне.",
        "cancelled": "Автопродовження припиниться {{date}}.",
        "cancelledNoDate": "Автопродовження вимкнено.",
        "cancelAction": "Скасувати автопродовження",
        "resumeAction": "Відновити автопродовження",
        "modalCancelTitle": "Скасувати автопродовження?",
        "modalResumeTitle": "Відновити автопродовження?",
        "modalCancelDescription": "Доступ збережеться до {{date}}. Після цього ваш план перейде на безкоштовний.",
        "modalResumeDescription": "Ваша підписка продовжуватиметься кожного періоду.",
        "modalConfirmCancel": "Скасувати автопродовження",
        "modalConfirmResume": "Відновити автопродовження",
        "modalDismiss": "Назад",
        "toastDisabled": "Автопродовження вимкнено",
        "toastDisabledWithDate": "Автопродовження припиниться {{date}}",
        "toastEnabled": "Автопродовження увімкнено",
        "cancelSuccess": "Автопродовження вимкнено",
        "cancelError": "Не вдалося вимкнути автопродовження",
        "resumeSuccess": "Автопродовження увімкнено",
        "resumeError": "Не вдалося увімкнути автопродовження",
        "unknownDate": "невідому дату"
      },
      "promo": {
        "title": "Промокоди",
        "placeholder": "Введіть промокод",
        "applyCta": "Застосувати",
        "clearCta": "Прибрати",
        "successTitle": "Промокод застосовано",
        "errorTitle": "Не вдалося застосувати промокод",
        "modalOk": "Зрозуміло",
        "successFallback": "Промокод прийнято.",
        "infoAppliedToPlan": "Промокод буде застосовано під час оплати для плану {{plan}}.",
        "planNotEligible": "Промокод не застосовується до плану {{plan}}.",
        "appliedTag": "Промокод застосовано: {{code}}",
        "discount": {
          "percent": "Знижка {{value}}%",
          "amount": "Знижка {{value}}"
        },
        "success": "Промокод успішно застосовано.",
        "validating": "Перевіряємо промокод…",
        "applying": "Застосовуємо промокод…",
        "statuses": {
          "valid": "Промокод дійсний.",
          "reserved": "Промокод зарезервовано для оплати."
        },
        "errors": {
          "promo_missing_code": "Введіть промокод, щоб продовжити.",
          "not_found": "Промокод не знайдено.",
          "expired": "Цей промокод прострочено.",
          "assigned_to_other": "Цей промокод призначено іншому користувачу.",
          "plan_not_allowed": "Промокод не можна застосувати до обраного плану.",
          "maxed_out": "Промокод досяг максимального ліміту використань.",
          "already_used": "Ви вже використали цей промокод.",
          "reservation_failed": "Промокод більше недоступний.",
          "promo_invalid": "Промокод не можна застосувати.",
          "promo_reservation_failed": "Не вдалося зарезервувати промокод. Спробуйте пізніше.",
          "promo_stripe_error": "Stripe відхилив промокод. Спробуйте ще раз або зверніться до підтримки.",
          "subscription_not_found": "Активну підписку не знайдено.",
          "stripe_not_configured": "Платежі тимчасово недоступні.",
          "unauthorized": "Потрібно увійти, щоб застосувати промокод."
        }
      },
      "planCard": {
        "selectCta": "Обрати план",
        "upgradeCta": "Оновити",
        "selectedCta": "Обрано",
        "currentTag": "Поточний",
        "selectedTag": "Обраний",
        "promoEligible": "Промокод доступний",
        "promoNotEligible": "Промокод недоступний",
        "perMonth": "на місяць",
        "discountedPrice": "Після промо: {{price}}",
        "aiCreditsPerPeriod": "{{count}} AI‑кредитів / місяць"
      },
      "friends": {
        "title": "Friends Plan",
        "subtitle": "Доступ лише за запрошенням для друзів проєкту.",
        "details": "Одноразовий доступ на 4 місяці з 5 AI‑кредитами щомісяця. Після цього план завершується автоматично.",
        "price": "Ціна: {{price}}",
        "cta": "Активувати Friends Plan"
      },
      "statuses": {
        "inactive": "Неактивний",
        "trialing": "Пробний",
        "active": "Активний",
        "past_due": "Прострочено",
        "unpaid": "Неоплачено",
        "incomplete": "Не завершено",
        "incomplete_expired": "Не завершено (термін минув)",
        "paused": "Призупинено",
        "canceled": "Скасовано",
        "grace": "Пільговий період",
        "expired": "Термін минув"
      }
    }
  }
};

export default resources;
